import { normalizeOpenApiError } from "./normalizeOpenApiError";

/**
 * openapi-fetch returns `{ error: undefined }` for a non-2xx with an empty
 * body, so `if (error)` alone lets a bodyless 502/504 through as a success.
 */
export const assertOpenApiOk = (
  error: unknown,
  response: Response | undefined,
): void => {
  if (error) {
    const normalized = normalizeOpenApiError(error);
    normalized.code ??= response?.status;
    throw normalized;
  }

  if (!response?.ok) {
    throw normalizeOpenApiError({
      code: response?.status,
      message: `Request failed with status ${response?.status ?? "unknown"}`,
    });
  }
};
